import { ampli } from "@/ampli"
import { Button } from "@/elements"
import Link from "next/link"

interface Props {
  viewerCreativeHandle: string
  className?: string
  entryPoint: string
}

export const PostAProjectButton: React.FC<Props> = ({ viewerCreativeHandle, className, entryPoint }) => {
  return (
    <Link
      href={`/${viewerCreativeHandle}/projects/form`}
      onClick={() =>
        ampli.postAProjectStart({
          entry_point: entryPoint,
        })
      }>
      <Button className={className}>Post a project</Button>
    </Link>
  )
}
